import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('my-modal', {
    attrs: {
      "width": 800,
      "data-sign": "pay_account_log_modal",
      "title": _vm.t('操作日志')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "data-sign": "pay_account_log_list_table",
      "data-source": _vm.tbodyData,
      "row-key": "_rowKey"
    }
  }), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };